export const findDepotMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Depot>,
  depotId: string,
): uui.domain.ui.map.markers.Depot | undefined => {
  const marker = markers[depotId]

  return marker
}
